
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.772 20.673l-4.88-4.881a8.379 8.379 0 001.943-5.374C18.835 5.776 15.06 2 10.418 2 5.776 2 2 5.776 2 10.418c0 4.641 3.776 8.417 8.418 8.417 2.041 0 3.915-.73 5.373-1.944l4.881 4.881a.775.775 0 001.1 0 .778.778 0 000-1.1zM3.555 10.418a6.87 6.87 0 016.863-6.863 6.87 6.87 0 016.862 6.863 6.87 6.87 0 01-6.862 6.862 6.87 6.87 0 01-6.863-6.862z","fill":"currentColor"}})])
          )
        }
      }
    